import React from 'react';

import { Confirmation } from './Confirmation';

interface Props {
  onDelete: () => void;
  onCancel: () => void;
  info?: string;
  showSpinner?: boolean;
}

export const DeleteConfirmation: React.FC<Props> = ({ info, onDelete, onCancel, showSpinner }) => (
  <Confirmation
    data-testid="delete-confirm"
    question="Are you sure?"
    info={info}
    primaryText="Yes"
    onPrimaryAction={onDelete}
    secondaryText="No"
    onSecondaryAction={onCancel}
    showSpinner={showSpinner}
  />
);
